jQuery(document).ready(function($) {

	const $body = $('body');
	const $window = $(window);

	smoothScrollInit($);
	hamburgerToggleInit($, $body);
	minicartTriggerInit($, $body);
	wcAddedToCartInit($, $body);
	addCutleryToCartInit($, $body);
	scrollToTopInit($, $body);
	scrollWatcherInit($, $body, $window);
	suggestionsUpdateCheckoutTotalInit($, $body);
	modalSuggestionsInit($, $body);

});

function modalSuggestionsInit($, $body) {
	const $modalTrigger = $('.js-modal-suggestions-trigger');
	$modalTrigger.on('click', function(e) {
		$body.toggleClass('modal-suggestions-inactive');
	});
}

function suggestionsUpdateCheckoutTotalInit($, $body) {

	const $suggestionsContainer = $('.js-suggestions');

	$suggestionsContainer.on('click', '.ajax_add_to_cart', function() {
		$body.trigger('update_checkout');
	});

}

jQuery(window).on("load", function(e) {

	jQuery("body").removeClass("preload");

});

function scrollWatcherInit($, $body, $window){

	var scrollClass = 'scrolled';

	if ($(document).scrollTop() > 50) {
			$body.addClass(scrollClass);
		}

	$window.scroll(function() {
		if ($(document).scrollTop() > 50) {
			$body.addClass(scrollClass);
		}
		else {
			$body.removeClass(scrollClass);
		}
	});
}


function scrollToTopInit($, $body) {

	$body.on('click', '.scroll-to-top', function(){
		$('html').animate({scrollTop:0}, '500');
	})

}

function hamburgerToggleInit($, $body) {

	const $hamburgerIcon = $('#hamburger-icon');

	$hamburgerIcon.on("click", function(e) {

		$hamburgerIcon.toggleClass('is-active');
		$body.toggleClass('hamburger-active');

	});

}

function smoothScrollInit($) {

	$('a[href*=\\#]:not([href=\\#])').click(function() {

		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {

			var target = $(this.hash);

			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-100
				}, 800);
				return false;
			}
		}
		
	});

}

function minicartTriggerInit($, $body) {

	const minicartTriggerSelector = '.js-minicart-trigger';

	$body.on("click", minicartTriggerSelector, function(e) {
		e.preventDefault();
		$body.toggleClass('minicart-active');
	});

}

function wcAddedToCartInit($, $body) {

	$body.on( 'added_to_cart', function(e, fragments, cart_hash, this_button) {

		if ( !$body.hasClass('cart-has-items') )
			$body.addClass('cart-has-items');

		$body.removeClass('added-to-cart-event');
		$body.addClass('added-to-cart-event');

	});

}

function addCutleryToCartInit($, $body) {

	$body.on( 'click', '.js-cutlery-add-to-cart', function(e) {

		$.ajax({
			url: localizedData.adminUrl,
			type: "POST",
			cache: false,
			data: {
				action: 'callback_add_cutlery_to_cart'
			},
			success: function(res) {
				if (res.success == true) {
					$body.trigger('wc_fragment_refresh');
					console.log(res);
				}
			}
		});
	});

}


/*-----------------------------------------------------------------------------------------*/
/* Utilities */
/*-----------------------------------------------------------------------------------------*/

/**
 * Returns string content of a cookie
 * @param {string} k Cookie name
 */
function getCookie(k){
    var v=document.cookie.match('(^|;) ?'+k+'=([^;]*)(;|$)');
    return v?v[2]:null
}

/**
 * 
 * @param {string} name Name of the cookie to be set
 * @param {*} data Content of the cookie, Objects will be stringified
 * @param {number} hours Max age hours
 * @param {number} days Max age days
 */
function setCookie( name, data, hours = 0.125, days = 1 ) {

    if (data === null)
        return;

    const maxAge = days*hours*60*60;

    if (typeof data === 'object')
        data = JSON.stringify(data);
    
    document.cookie = name + '=' + data + '; max-age=' + maxAge + '; path=/';

}

/**
 * Retrives cookie, unstringifies it's content, set new keys values and replace it
 * @param {Object} data Object of keys to be updated
 * @param {string} name Name of the cookie to be set
 * @param {number} hours Max age hours
 * @param {number} days Max age days
 */
function setCookieKeys( data = {}, name = 'user-filter', hours = 0.125, days = 1 ) {

    const cookieString = getCookie( name );
    let cookieObj = {};

    if ( cookieString ) {
		

        cookieObj = JSON.parse(cookieString);

        for ( const [key,value] of Object.entries( data ) ) {
            // if the value has not been clearly specified as null/false/0 do not set the key
            if ( value.length || typeof value === 'object'  || typeof value === 'number') {
                cookieObj[key] = value;
            }

        }

    }
    else {
        cookieObj = data;
    }

    setCookie( name, cookieObj, hours, days );

}
